import type * as React from 'react';

import { toDayLocaleDateString } from '../Intl';

/**
 * Format a date in a month/day format.
 */
export function DatePrettyDay(props: { value: Date; className?: string }): React.ReactElement {
    const { value } = props;

    return <span className={props.className}>{prettyDate(value)}</span>;
}

/**
 * Return native locale date string using the weekday.
 * By default you will get "Yesterday" and "Today" for appropriate dates,
 * to override that prop relative should be false.
 */
export function prettyDate(
    date: Date,
    options: { relative: boolean } = {
        relative: true,
    }
): string {
    const { relative } = options;
    const today = new Date();
    const timeDiff = date.getTime() - today.getTime();
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    if (relative) {
        if (diffDays === -1) {
            return 'Yesterday';
        }

        if (diffDays === 0) {
            return 'Today';
        }
    }

    return toDayLocaleDateString(date);
}
